import script from "./BulkActionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BulkActionModal.vue?vue&type=script&setup=true&lang=js"

import "./BulkActionModal.vue?vue&type=style&index=0&id=0515f5de&lang=css"

const __exports__ = script;

export default __exports__